import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Cliente } from 'src/app/admihair/api/dto/cliente';
import { Paginador } from 'src/app/admihair/api/dto/paginacao/paginador';
import { LazyLoadEvent, SelectItem } from 'primeng/api';
import { ClienteService } from 'src/app/admihair/service/cliente.service';
import { Table } from 'primeng/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Orcamento } from 'src/app/admihair/api/dto/orcamento';
import { OrcamentoService } from 'src/app/admihair/service/orcamento.service';

@Component({
  selector: 'app-central-cliente-listar',
  templateUrl: './central-cliente-listar.component.html',
  styleUrls: ['./central-cliente-listar.component.scss']
})
export class CentralClienteListarComponent extends AdmihairBaseComponent implements OnInit {


  clientes: Cliente[] = [];
  clienteSelecionado?: Cliente;
  loadingTable: boolean = false;
  situacoesStatus: SelectItem[] = [{ label: 'ATIVOS', value: true },
    { label: 'INATIVOS', value: false }];
  situacaoSelecionada: boolean = true;

  itensPaginados?: Paginador<Cliente>;
  numeroPagina: number = 0;
  inputBusca?: string = '';
  ordenacao: string = 'nome,ASC';
  tamanhoPagina: number = 10;


  loadingDialogPacotes: boolean = false;
  exibirDialogContasPacotes: boolean = false;
  listaPacotesClienteSelecionado: Orcamento[] = [];


  exibirDialogRetornos: boolean = false;

  @ViewChild('filter') filter!: ElementRef;

  constructor(private clienteService: ClienteService,
    private orcamentoService: OrcamentoService,
    erroService: ErroService,
    storageService: UtilStorageService,
    router: Router,
    activatedRoute: ActivatedRoute) {
    super(erroService, storageService, router, activatedRoute)
  }

  ngOnInit(): void {
    this.permissaoListar = this.verificarPermissao('PERM_LISTAR_CENTRAL_CLIENTE');
  }

  listarClientes(pagina?: number) {
      this.loadingTable = true;
      this.clienteService.listarClientesPorEmpresaESituacaoETextoBuscaPaginado(this.getEmpresa().id, this.situacaoSelecionada,
        pagina, this.tamanhoPagina, this.ordenacao, this.inputBusca).subscribe({
        next: (data: Paginador<Cliente>) => {
          this.itensPaginados = data;
          this.clientes = data.content;
          this.loadingTable = false;
        },
        error: (err: any) => {
          this.loadingTable = false;
          this.exibirMensagemErro(err)
        }
      });
    }
  
    onLazyLoad(event: LazyLoadEvent) {
      if(event.first !== undefined && event.rows !== undefined) {
        if (event.first === 0 && event.rows === 0) {
          this.numeroPagina = 0;
        } else {
          this.numeroPagina = event.first / event.rows;
        }
      }
      this.definirOrdenacao(event.sortField, event.sortOrder);
      this.loadingTable = true;
      this.listarClientes(this.numeroPagina);
    }
  
    definirOrdenacao(sortField?: string, sortOrder?: number) {
      const campoDeOrdenacao = sortField ? sortField : 'nome';
      const direcaoOrdenacao = sortOrder === -1 ? 'DESC' : 'ASC';
      this.ordenacao = `${campoDeOrdenacao},${direcaoOrdenacao}`;
    }

    buscar(event: Event) {
      this.inputBusca = (event.target as HTMLInputElement).value;
      this.listarClientes(0);
    }
  
    limpar(table: Table) {
      this.filter.nativeElement.value = '';
      this.inputBusca = '';
      table.clear()
    }

    abrirDialogContasEPacotes(cliente: Cliente){
      this.clienteSelecionado = cliente;
      this.exibirDialogContasPacotes = true;
      this.loadingDialogPacotes = true;
      this.listarPacotesCliente();
    }

    listarPacotesCliente() {
      this.orcamentoService.listarTodosPorEmpresaECliente(this.getEmpresa().id, this.clienteSelecionado?.id).subscribe({
        next: (data: Orcamento[]) => {
          this.listaPacotesClienteSelecionado = data;
          this.loadingDialogPacotes = false;
        },
        error: (err: any) => {
          this.loadingDialogPacotes = false;
          this.exibirDialogContasPacotes = false;
          this.exibirMensagemErro(err);
        }
      })
    }

    redirecionarParaPacote(clienteSelecionado: Cliente) {
      this.clienteService.selecionarCliente(clienteSelecionado);
      this.redirecionarPagina('/apps/central-cliente/pacote/cliente/' + clienteSelecionado.id);
    }

    

}
